import React from 'react';

// level 0 pages
import HomePage from './HomePage/HomePage';

// level 1 pages
import AboutPage from './AboutPage/AboutPage';
import ContactUsPage from './ContactUsPage/ContactUsPage';
import EducationPage from './EducationPage/EducationPage';
import HeritagePage from './HeritagePage/HeritagePage';
import InspirationPage from './InspirationPage/InspirationPage';
import NewsAndEventsPage from './NewsAndEventsPage/NewsAndEventsPage';
import OurAssetsPage from './OurAssetsPage/OurAssetsPage';
import SalonInfoUpdatePage from './SalonInfoUpdatePage/SalonInfoUpdatePage';
import SeminarSchedulePage from './SeminarSchedulePage/SeminarSchedulePage';
import Sitemap from './Sitemap/Sitemap';
import TermsPage from './TermsPage/TermsPage';
import TermsColorMirrorPage from './TermsColorMirrorPage/TermsColorMirrorPage';
import CreatorsPage from './CreatorsPage/CreatorsPage';
import RecruitPage from './RecruitPage';

// level 2 pages
import EditorialPageConnected from './EditorialPage/EditorialPage';
import ProductPage from './ProductPage/ProductPage';
import SeminarPage from './SeminarPage/SeminarPage';
import StylePage from './StylePage/StylePage';
import TreatmentPage from './TreatmentPage/TreatmentPage';
import SalonList from './SalonList';
import SalonListGrooming from './SalonListGrooming';
import BeautyForYouArticlePage from './HairDiagnosis/HairDiagnosisPage/ArticlePage';

// level 3 pages
import RangePage from './RangePage/RangePage';
import InspirationArticlePage from './InspirationPage/ArticlePage';

import { slugToContentType } from './RangePage/rangeNameConverter';

const pageList = {
  lvl0: [
    {
      pageSlug: '',
      component: data => <HomePage data={data} />,
      contentType: 'homePage',
      dataModel: {
        entryId: 'string',
        featuredProductRanges: [{ productImage: { assetId: 'string' } }],
        manifestos: [],
        topics: [],
      },
    },
  ],
  lvl1: [
    {
      pageSlug: 'about',
      component: (data, location, locale) => <AboutPage data={data} location={location} locale={locale} />,
      contentType: 'aboutPage',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'contact-us',
      component: (data, location, locale) => <ContactUsPage data={data} location={location} locale={locale} />,
      contentType: 'contactUsPage',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'salon-info-update',
      component: (data, location, locale) => <SalonInfoUpdatePage data={data} location={location} locale={locale} />,
    },
    {
      pageSlug: 'education',
      component: (data, location, locale) => <EducationPage data={data} location={location} locale={locale} />,
      contentType: 'educationPage',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'heritage',
      component: (data, location, locale) => <HeritagePage data={data} location={location} locale={locale} />,
      contentType: 'heritagePage',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'inspiration',
      component: (data, location, locale) => <InspirationPage data={data} location={location} locale={locale} />,
      contentType: 'inspirationPage',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'news-and-events',
      component: (data, location, locale) => <NewsAndEventsPage data={data} location={location} locale={locale} />,
      contentType: 'newsAndEventsPage',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'assets',
      component: (data, location, locale) => <OurAssetsPage data={data} location={location} locale={locale} />,
      contentType: 'ourAssetsPage',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'seminar-schedule',
      component: (data, location, locale) => <SeminarSchedulePage data={data} location={location} locale={locale} />,
      contentType: 'seminarSchedulePage',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'sitemap',
      component: () => <Sitemap />,
    },
    {
      pageSlug: 'creators',
      component: (data, location, locale) => <CreatorsPage data={data} location={location} locale={locale} />,
      contentType: 'creatorsPage',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'terms-of-use',
      component: (data, location, locale) => <TermsPage data={data} location={location} locale={locale} />,
      contentType: 'termsOfUse',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'terms-of-use-colormirror',
      component: (data, location, locale) => <TermsColorMirrorPage data={data} location={location} locale={locale} />,
      contentType: 'termsOfUseColorMirror',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'recruit',
      component: (data, location, locale) => <RecruitPage data={data} location={location} locale={locale} />,
      contentType: 'recruitPage',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'salon-list-tgm-kit',
      component: data => <SalonListGrooming data={data} />,
      contentType: 'salon-list-tgm-kit',
      dataModel: { entryId: 'string' },
    },
  ],
  lvl2: [
    {
      pageSlug: 'inspiration',
      component: data => <EditorialPageConnected data={data} />,
      contentType: 'editorial',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'product',
      component: (data, location, locale) => <ProductPage data={data} location={location} locale={locale} />,
      contentType: 'product',
      dataModel: {
        entryId: 'string',
        variants: [{ image: { assetId: 'string' } }],
        relatedProducts: [{ variants: [{ image: { assetId: 'string' } }] }],
      },
    },
    {
      pageSlug: 'education',
      component: (data, location, locale) => <SeminarPage data={data} location={location} locale={locale} />,
      contentType: 'seminarSpecifics',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'style',
      component: (data, location, locale) => <StylePage data={data} location={location} locale={locale} />,
      contentType: 'style',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'treatment',
      component: (data, location, locale) => <TreatmentPage data={data} location={location} locale={locale} />,
      contentType: 'treatment',
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'beautyforyou',
      component: (data, location, locale) => (
        <BeautyForYouArticlePage data={data} location={location} locale={locale} />
      ),
      contentType: 'articlePage',
      dataModel: { entryId: 'string' },
    },
  ],
  // contentType のコールバック処理において、子階層 (lvl2) の slug が引き渡される
  //   * 例) 親階層 (lvl1) = range、子階層 (lvl2) = hair-care
  lvl3: [
    {
      pageSlug: 'range',
      component: (data, location, locale) => <RangePage data={data} location={location} locale={locale} />,
      contentType: slug => slugToContentType(slug),
      dataModel: { entryId: 'string', heroImage: { assetId: 'string' } },
    },
    {
      pageSlug: 'salon-list',
      component: (data, location, locale) => <SalonList data={data} location={location} locale={locale} />,
      contentType: slug => slugToContentType(slug),
      dataModel: { entryId: 'string' },
    },
    {
      pageSlug: 'inspiration',
      component: (data, location, locale) => <InspirationArticlePage data={data} location={location} locale={locale} />,
      contentType: () => 'inspirationArticle',
      dataModel: { entryId: 'string' },
    },
  ],
};

const slugToPageMap = Object.keys(pageList).reduce(
  (map, key) => ({
    ...map,
    [key]: pageList[key].reduce((map, page) => ({ ...map, [page.pageSlug]: page }), {}),
  }),
  {}
);

export const getComponent = (lvl1 = '', lvl2, lvl3) => {
  let page;
  if (lvl3) {
    page = slugToPageMap.lvl3[lvl1];
  } else if (lvl2) {
    page = slugToPageMap.lvl2[lvl1];
  } else if (lvl1) {
    page = slugToPageMap.lvl1[lvl1];
  } else {
    page = slugToPageMap.lvl0[lvl1];
  }
  return page ? page.component : undefined;
};

/**
 * contentType を受け取る処理
 *   第一引数 lvl1: 親階層のパスが引き渡される。(例) range、salon-list)
 *   第二引数 lvl2: 子階層の slug が引き渡される。(例) hair-care)
 *   第三引数 lvl3: 孫階層の slug が引き渡される。(例) sublimic)
 */
export const getContentType = (lvl1 = '', lvl2, lvl3) => {
  if (lvl3) {
    return slugToPageMap.lvl3[lvl1].contentType(lvl2);
  } else if (lvl2) {
    return slugToPageMap.lvl2[lvl1].contentType;
  } else if (lvl1) {
    return slugToPageMap.lvl1[lvl1].contentType;
  }
  return slugToPageMap.lvl0[lvl1].contentType;
};

export const getDataModel = (lvl1 = '', lvl2, lvl3) => {
  let page;
  if (lvl3) {
    page = slugToPageMap.lvl3[lvl1];
  } else if (lvl2) {
    page = slugToPageMap.lvl2[lvl1];
  } else if (lvl1) {
    page = slugToPageMap.lvl1[lvl1];
  } else {
    page = slugToPageMap.lvl0[lvl1];
  }

  return page ? page.dataModel : undefined;
};



// WEBPACK FOOTER //
// ./src/pages/pageList.js